export const REMOVE_BUTTON_TEXT = `Удалить файл`;
